import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, retry, shareReplay } from 'rxjs';
import { MyKeyValue } from 'src/models/myKeyValue';
import { AppSettings } from '../app-settings';
import { NotificationFilterType } from 'src/models/notificationFilterType';

@Injectable({
    providedIn: 'root',
})
export class TypesService {

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(private http: HttpClient, private appSettings: AppSettings) { }

    getChurchFamiliesCount(): Observable<MyKeyValue[]> {
        let url = this.appSettings.apiBaseUrl() + 'Types/GetChurchFamiliesCount';
        return this.http.get<MyKeyValue[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    getCities(): Observable<MyKeyValue[]> {
        let url = this.appSettings.apiBaseUrl() + 'Types/GetCities';
        return this.http.get<MyKeyValue[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    getPriests(): Observable<MyKeyValue[]> {
        let url = this.appSettings.apiBaseUrl() + 'Types/GetPriests';
        return this.http.get<MyKeyValue[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    getOccupations(): Observable<MyKeyValue[]> {
        let url = this.appSettings.apiBaseUrl() + 'Types/GetOccupations';
        return this.http.get<MyKeyValue[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    getProfessions(): Observable<MyKeyValue[]> {
        let url = this.appSettings.apiBaseUrl() + 'Types/GetProfessions';
        return this.http.get<MyKeyValue[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    getSocialStatus(): Observable<MyKeyValue[]> {
        let url = this.appSettings.apiBaseUrl() + 'Types/GetSocialStatus';
        return this.http.get<MyKeyValue[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    getNotificationFilters(moduleName: string): Observable<NotificationFilterType[]> {
        let url = this.appSettings.apiBaseUrl() + 'Types/GetNotificationFilters?skipLoadingSpinner=1&moduleName=' + moduleName;
        return this.http.get<NotificationFilterType[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }
}